module.exports = __webpack_public_path__ + "static/image1.08a1b975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project1/image1.jpg
// module id = 126
// module chunks = 100667300852966 131627143932366